
import { createAction } from 'redux-actions'
import axios from 'axios';

// 获得用户积分流水
export const getScoreLogSucceeded = createAction('getScoreLog/GET_SUCCEEDED')
export const getScoreLogFailed = createAction('getScoreLog/GET_FAILED')

export function fetchgetScoreLog(params) {
  return dispatch => (
    axios.get('/api/find/scorelog', { params })
      .then(response => dispatch(getScoreLogSucceeded(response)))
      .catch(error => dispatch(getScoreLogFailed(error)))
  )
}

// 导出积分流水信息
export const getScoreLogExportRequested = createAction('scoreLogExport/GET_REQUESTED')
export const getScoreLogExportSucceeded = createAction('scoreLogExport/GET_SUCCEEDED')
export const getScoreLogExportFailed = createAction('scoreLogExport/GET_FAILED')

export function fetchGetScoreLogExport(params) {
  return (dispatch) => {
    dispatch(getScoreLogExportRequested);
    return axios.get('/api/find/getScoreLogExcel', { params })
      .then(response => dispatch(getScoreLogExportSucceeded(response)))
      .catch(error => dispatch(getScoreLogExportFailed(error)));
  }
}




// WEBPACK FOOTER //
// ./actions/scoreLog.js